import { Component, Input, OnInit } from '@angular/core';
import { VariablesService } from '../../services/variables.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-guest-variables',
  standalone: false,
  templateUrl: './guest-variables.component.html',
  styleUrl: './guest-variables.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class GuestVariablesComponent {
  @Input() guest: any;
  dietaryDescription;
  mealList;
  personalConsiderationsList;
  considerationReasonList;
  adaSeating;

  constructor(
    private variablesService: VariablesService,
    private registrationService: RegistrationService
  )
  {
    this.mealList = [
      {name: 'None', code: ''},
      {name: 'Dairy-Free', code: 'DAIRYFREE'},
      {name: 'Food Allergy', code: 'FOODALLE'},
      {name: 'Gluten-Free', code: 'GLUTFREE'},
      {name: 'Halal', code: 'HALAL'},
      {name: 'Kosher', code: 'KOSHER'},
      {name: 'No Pork', code: 'NOPORK'},
      {name: 'Pescatarian', code: 'PESCATARIAN'},
      {name: 'Vegan', code: 'VEGAN'},
      {name: 'Vegetarian', code: 'VEGTRIAN'},
      {name: 'Other', code: 'OTHER'}
    ];
    this.personalConsiderationsList = [
      {name: 'None', code: 'NONE'},
      {name: 'Diabetic', code: 'DIABETIC'},
      {name: 'Hearing Impaired', code: 'HRNGIMPD'},
      {name: 'Visually Impaired', code: 'VISLIMPD'},
      {name: 'Wheelchair Access', code: 'WHLCHAIR'},
      {name: 'Other', code: 'OTHER'}
    ];
    this.considerationReasonList = [
      { name: "Allergy (Eating the food)" },
      { name: "Allergy (Touching the food)" },
      { name: "Allergy (Cannot be in the same room)" },
      { name: "Lifestyle" },
      { name: "Other" },
    ];

  }
  ngOnInit(): void {
    this.dietaryDescription = this.registrationService.getVariable(this.guest, this.variablesService.VARIABLE.varDietaryDescription.ID, {});
    this.adaSeating = this.registrationService.getVariable(this.guest, this.variablesService.VARIABLE.varAdaSeating.ID, {});
  }

  mealUpdate(guest, meal) {
    if ( meal.name !== undefined ) {
      if ( guest.DietaryConsiderations === undefined ) {
        guest.DietaryConsiderations = "";
      } else {
        //Create the string if it didn't exist
        if (!guest.DietaryConsiderations.includes(meal.name) && (guest.DietaryConsiderations === "" || guest.DietaryConsiderations === undefined)) {
          guest.DietaryConsiderations =  meal.name;
        }
        //If None is selected, remove all other meal considerations and set to None
        else if (meal.name === "None" && !guest.DietaryConsiderations.includes(meal.name)) {
          guest.DietaryConsiderations =  meal.name;
          guest.$mtcdietaryOtherCheckbox = false;
          guest.$mtcallergyCheckbox = false;
        }
        //Remove None and replace with new consideration
        else if (meal.name !== "None" && guest.DietaryConsiderations.includes("None")) {
          guest.DietaryConsiderations = meal.name;
        }
        //Add new meal consideration to list if doesn't exist
        else if (!guest.DietaryConsiderations.includes(meal.name)) {
          guest.DietaryConsiderations =  guest.DietaryConsiderations + "," + meal.name;
        } 
        //Remove meal consideration from list if exists
        else {
          guest.DietaryConsiderations = guest.DietaryConsiderations.replace("," + meal.name, "").replace(meal.name, "");
          if(guest.DietaryConsiderations[0] === ","){
            guest.DietaryConsiderations = guest.DietaryConsiderations.slice(1,guest.DietaryConsiderations.length);
          }
        }
        //Show followup dietary question for these options
        if ( guest.DietaryConsiderations.includes("Dairy-Free") || guest.DietaryConsiderations.includes("Food Allergy") || guest.DietaryConsiderations.includes("Gluten-Free") ) {
          guest.$mtcShowDietaryDescription = true;
        }
        else {
          guest.$mtcShowDietaryDescription = false;
        }
      }
    }
  }

  hasdietary(guest) {
    if (guest.DietaryConsiderations !== undefined) {
      if (guest.DietaryConsiderations.length > 1) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }

  removeExclamation(event){
    if ( event.keyCode === 33 ) {
      return false;
    }
  }

  includes(arr, val) {
    return _.includes(arr, val);
  }

  considerationUpdate(consideration, guest) {
    let justadded = false;

    if (guest.DisabilityType === undefined) {
      guest.DisabilityType = [];
      guest.DisabilityType = this.registrationService.getDisabilities(guest, "");
    }

    if (!_.includes(guest.DisabilityType, consideration.code)) {
      //Adding None Resets List, None then pushed onto it below
      if (consideration.code === "NONE") {
        guest.DisabilityType = [];
      }
      //Remove None if another consideration is added
      else if (consideration.code !== "NONE" && _.includes(guest.DisabilityType, "NONE")) {
        let index = guest.DisabilityType.indexOf("NONE");
        if (index !== -1) {
         guest.DisabilityType.splice(index, 1);
        }
      }
      //Finally, add new consideration to list
      guest.DisabilityType.push(consideration.code);
      justadded = true;
      if(consideration.code === "OTHER"){
        guest.$mtcadaOtherCheckbox = true;
      }
    }
    if (justadded === false && _.includes(guest.DisabilityType, consideration.code)) {
      let index = guest.DisabilityType.indexOf(consideration.code);
      if (index !== -1) {
        guest.DisabilityType.splice(index, 1);
      }
      if(consideration.code === "OTHER"){
        guest.$mtcadaOtherCheckbox = false;
      }
    }
  }

  haspersonalconsiderations(guest) {
    if(!guest.DisabilityType){
      guest.DisabilityType=[];
    }

    if (guest.DisabilityType !== undefined) {
      if (guest.DisabilityType.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
